import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DemographyEffects, demographyReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([DemographyEffects]), StoreModule.forFeature(`demography`, demographyReducer)]
})
export class DemographyStateModule {}
